import Link from "next/link";
import { Stack } from "@mui/material";
import { MdInfoOutline } from "react-icons/md";

import { routes } from "src/shared/routes";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import { SSText } from "src/components/base/components/SSText";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Sign Up for ISU Student Athlete Tickets",
    description:
      "Sign up for your Student Athlete Ticket and link your account with other Student Athletes to be assigned seats together. You must use your Iowa State email address at sign up.",
    authRedirectPage: routes.home,
    buttonLabel: "Sign Up",
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "What games are a part of my pass?",
    answer:
      "All games a part of your eligibility are in your Upcoming Events tab.",
  },
  {
    question: "How are tickets sent to me?",
    answer: (
      <>
        You will receive a text message the day before the game with a link to
        manage your tickets in your Iowa State{" "}
        <Link href="https://am.ticketmaster.com/isu/" target="_blank">
          Account Manager
        </Link>
        .
      </>
    ),
  },
  {
    question: "Can I link my seats with friends?",
    answer: (
      <>
        Yes! Navigate to the{" "}
        <Link
          href={{
            pathname: routes.my_group,
            query: { teamSchema: "iowastate_cyclones" },
          }}
        >
          My Groups
        </Link>{" "}
        tab and create a unique link to share with your friends. You will all be
        seated close together during the game.
      </>
    ),
  },
  {
    question: "Can my tickets be transferred to a friend?",
    answer:
      "Your tickets are non-transferable and not eligible for resale. Abusing these guidelines can result in your pass being revoked.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const ADD_ON_PURCHASE_SUCCESS_MESSAGE = {
  TITLE: () => <>You&apos;re all set to experience the action!</>,
  DESCRIPTION: () => {
    const router = useRouterExt();
    return (
      <>
        <b>
          <u>
            <span
              onClick={() => router.pushSchema(routes.my_group)}
              style={{ cursor: "pointer" }}
            >
              Invite your friends
            </span>
          </u>
        </b>{" "}
        to join your group!
      </>
    );
  },
};

export const SWAF_INFO_TEXT = () => (
  <Stack
    p={1}
    my={2}
    gap={1}
    borderRadius={2}
    bgcolor="#CEE8F0"
    alignItems="center"
    flexDirection="row"
    flexWrap="nowrap"
  >
    <MdInfoOutline
      color="#014361"
      style={{
        flexShrink: 0,
        fontSize: 22,
        minWidth: 24,
        minHeight: 24,
      }}
    />
    <SSText
      variant="body2"
      color="#014361"
      sx={{
        wordBreak: "break-word",
        fontSize: { xs: "1rem", sm: "1rem" },
        lineHeight: 1.4,
        fontWeight: 400,
        display: "inline",
      }}
    >
      Group formation closes Tuesday at 5PM the week prior to a game. Any groups
      formed after that time will not be accounted for in your seat assignment.
    </SSText>
  </Stack>
);
